import {Moreless} from './moreless';

const initMoreless = () => {
  const blocks = document.querySelectorAll('[data-moreless]');

  blocks.forEach((block) => {
    const moreless = new Moreless(block);
    moreless.init();
  });
};

export {initMoreless};
